const appConfig = {
  "name": "onboarding-web-test",
  "version": "0.1.0",
  "stage": "test",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://okta.mit.edu/oauth2/aus6shd5478WH30vd697",
    "clientId": "4pme2dup92bfse16h8h692hg99",
    "redirectUris": [
      "https://onboarding.atlas-apps-test.mit.edu/"
    ],
    "postLogoutRedirectUris": [
      "https://onboarding.atlas-apps-test.mit.edu/logout"
    ],
    "scopes": [
      "covid19/user",
      "digital-id/user",
      "onboarding/user",
      "openid",
      "profile",
      "user/admin.visiting-student",
      "user/all"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_nY154N4yV",
    "userPoolWebClientId": "4pme2dup92bfse16h8h692hg99",
    "oauth": {
      "domain": "atlas-auth-test.mit.edu",
      "scope": [
        "covid19/user",
        "digital-id/user",
        "onboarding/user",
        "openid",
        "profile",
        "user/admin.visiting-student",
        "user/all"
      ],
      "redirectUris": [
        "https://onboarding.atlas-apps-test.mit.edu/"
      ],
      "postLogoutRedirectUris": [
        "https://onboarding.atlas-apps-test.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;